import httpBase from "../utils/http.utils";
import {
  CTA_ASSIGN_AGENT,
  CTA_BY_ID,
  CTA_FETCH,
  CTA_FILTERS,
  CTA_GET_AGENTS,
  CTA_GET_TOPICS,
  CTA_REPORTS,
  CTA_RESOLVE,
  GET_TOPIC,
} from "../constants/url";

export const getAllCtaDataApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(CTA_FETCH, [], {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const exportCtaReportsApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(CTA_REPORTS, {
        params,
        responseType: "blob",
      });
      successCallback(response);
    } catch (e) {
      try {
        const respData = e?.response?.data;
        let detail;

        if (respData) {
          // If server returned a blob (because responseType: 'blob'), read and parse it
          if (typeof Blob !== "undefined" && respData instanceof Blob) {
            const text = await respData.text();
            const json = JSON.parse(text || "{}");
            detail = json?.detail;
          } else if (typeof respData === "string") {
            try {
              const json = JSON.parse(respData);
              detail = json?.detail;
            } catch (parseErr) {
              // not JSON
            }
          } else if (respData?.detail) {
            detail = respData.detail;
          }
        }

        if (detail) {
          e.parsedDetail = detail;
        }
      } catch (parseErr) {
        // ignore parsing errors
      }
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getCtaFiltersApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(CTA_FILTERS, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getCtaTopicsApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(CTA_GET_TOPICS, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getTopicsApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_TOPIC, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const markCtaAsResolvedApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  const apiData = {
    cta_type: data.type,
    id: data.id,
    resolved_by: localStorage.getItem("username"),
    remarks: data.remarks,
  };

  return async (dispatch) => {
    try {
      const response = await httpBase().post(CTA_RESOLVE, apiData);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getAgentsApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(CTA_GET_AGENTS, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getCtaByIdApi = ({
  id,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(`${CTA_BY_ID}/${id}`);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const assignAgentApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(CTA_ASSIGN_AGENT, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};
